import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import Check from '@mui/icons-material/Check';
import FormatSize from '@mui/icons-material/FormatSize';
import { useFontSize } from '@/theme';

/**
 * Header dropdown to pick the app-wide font size. Its own button beside the theme-colors menu:
 * text size and colour are separate decisions, and a menu that mixed them made the palette list
 * scroll on short screens.
 */
export default function FontSizeMenu() {
  const { fontSizeId, setFontSizeId, fontSizes, fontSize } = useFontSize();
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  return (
    <>
      <Tooltip title={`Font size: ${fontSize.label}`}>
        <IconButton
          aria-label='Font size'
          aria-haspopup='menu'
          aria-controls={open ? 'font-size-menu' : undefined}
          aria-expanded={open || undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
        >
          <FormatSize />
        </IconButton>
      </Tooltip>
      <Menu
        id='font-size-menu'
        anchorEl={anchor}
        open={open}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ list: { dense: true, 'aria-label': 'Font size' } }}
      >
        <ListSubheader sx={{ lineHeight: '32px', bgcolor: 'transparent' }}>Font size</ListSubheader>
        {fontSizes.map((item) => {
          const selected = item.id === fontSizeId;
          return (
            <MenuItem
              key={item.id}
              selected={selected}
              aria-checked={selected}
              role='menuitemradio'
              onClick={() => {
                setFontSizeId(item.id);
                setAnchor(null);
              }}
              sx={{ gap: 1.5, pr: 5, minWidth: 180 }}
            >
              <ListItemText primary={item.label} />
              {selected && (
                <ListItemIcon sx={{ minWidth: 0, ml: 'auto' }}>
                  <Check fontSize='small' />
                </ListItemIcon>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
